import gql from 'graphql-tag';

export const getFormTemplates = gql`
  query GetFormTemplates(
    $FORM_ID: String
    $VERSION: String
    $VERTICAL: String
  ) {
    getFormTemplates(
      FORM_ID: $FORM_ID
      VERSION: $VERSION
      VERTICAL: $VERTICAL
    ) {
      AUTOFILL {
        QUESTION_ID
        TS_KEY
      }
      EXTRA {
        DEFAULT_MESSAGE
        TRANSLATION_ID
      }
      FORM_ID
      SECTIONS {
        ADDITIONAL_QUESTION_CONTEXT {
          DEFAULT_MESSAGE
          TRANSLATION_ID
        }
        QUESTION_TEXT {
          DEFAULT_MESSAGE
          TRANSLATION_ID
        }
        QUESTIONS {
          DEFAULT_SELECTED {
            DEFAULT_MESSAGE
            TRANSLATION_ID
            TYPE
            VALUE
          }
          QUESTION_ID
          QUESTION_OPTIONS {
            DEFAULT_MESSAGE
            TRANSLATION_ID
            TYPE
            VALUE
          }
          QUESTION_TEXT {
            DEFAULT_MESSAGE
            TRANSLATION_ID
          }
          QUESTION_TYPE
        }
        SECTION_ID
        TYPE
      }
      TITLE {
        DEFAULT_MESSAGE
        TRANSLATION_ID
      }
      VERSION
      VERTICAL
    }
  }
`;
